let getWorkKeysUrl = 'http://192.168.169.243:8210/HxAccsseControl/getWorkKeys'

let loginInfo = {}
let user = ''

let headerTitle = '智慧园区生活服务平台'

let saveKey = 'ED96777EBA40D09B'

let defaultMacKey = '485I68JyqQAI4te8n8qoimq0ug'
let defaultPinKey = '75AE4573F62EE476F8E5903659A9CD99'
let defaultToken = 'b1E7ks06eua024s3t1x7'

let isEncryption = true
let cryptionType = '3DES'

let schCode = '000000'

let showCleanSector = false
let supportOutsideCard = false

let clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
let clientHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
let contentWidth = clientWidth - 170 + 'px'
let contentHeight = clientWidth - 80 + 'px'
let needLoadingRequestCount = 0
let lastRequestFlag = false // 同时间段内最后一个请求标志
let ruleId = ''
let handleType = '0'
let initPageSize = 10
let initMaxPageSize = 10000
let initPageNum = 1
let timestamp = ''
let userId = ''
let userName = ''
let breadcrumbContent = []
let lastBreadcrumbContent = []
let privileges = []
let treeProps = {
  children: 'childNodeList',
  label: 'nodeName',
  value: 'nodeId'
}
let categoryTreeProps = {
  children: 'subList',
  label: 'categoryName',
  value: 'id'
}
let hideError = false
let noChangeTitle = '提交失败'
let noChangeMsg = '无法提交未修改的数据！'
let errorSubmit = '带红*的为必填项且必须填写正确！'
let lastBizList = []
let bizList = []
let menuList = []
let userPrivileges = [] // 登录用户的所有权限列表

// publicKey公钥
let publicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCL9LWLdhbSZXAwzr1cg6DSR582lvHdmZaDyVf9uqXGd95Wr9O9zHYxzKCjqzSJLPJxvGFWOl2NJ2PEh/GHUuU1kGvLYuQK+VDA/LjgITjz+RA4pxzVBc+/aj97E70VM8XklSR3+7Yls7brs5CkIxev13hlzTb2nCuptTzfOVwJ/QIDAQAB'
let pinKey = '' // pinKey用来加密密码
// mackeyObj用来存储mackey组  存储规则：接口代码:mackey
let macKeyObj = {}

let initMenuList = [
  {
    nodeName: '系统管理',
    nodeId: '1',
    childNodeList: [
      {
        nodeName: '机构管理',
        nodeId: '110',
        childNodeList: [
          {nodeName: '机构资料', nodeId: '1101', bizList: ['201', '202', '203', '204', '205', '206', '207', '208']},
          {nodeName: '机构参数', nodeId: '1102', bizList: ['205']}]
      },
      {nodeName: '系统参数', nodeId: '1201', bizList: ['101', '102']},
      {nodeName: '码表管理', nodeId: '1301', bizList: ['501', '502', '503', '504']},
      {nodeName: '工作日管理', nodeId: '1401', bizList: ['2001', '2002', '2003', '2004']},
      {nodeName: '跨区应用设置', nodeId: '1501', bizList: ['2101', '2102', '2103', '2104']},
      {
        nodeName: '支付渠道',
        nodeId: '160',
        childNodeList: [
          {nodeName: '支付渠道信息', nodeId: '1601', bizList: ['301', '302', '303', '304']},
          {nodeName: '商户支付应用配置', nodeId: '1602', bizList: ['401', '402', '403', '404']}
        ]
      },
      {
        nodeName: '操作员管理',
        nodeId: '170',
        childNodeList: [
          {nodeName: '角色管理', nodeId: '1701', bizList: ['2201', '2202', '2203', '2204', '2205', '2206']},
          {
            nodeName: '操作员管理',
            nodeId: '1702',
            bizList: ['2301', '2302', '2303', '2304', '2305', '2306', '2307', '2308']
          },
          {nodeName: '审计日志', nodeId: '1703', bizList: ['2401']}
        ]
      }
    ]
  },
  {
    nodeName: '应用基础管理',
    nodeId: '2',
    childNodeList: [
      {
        nodeName: '人员管理',
        nodeId: '210',
        childNodeList: [
          {nodeName: '部门资料管理', nodeId: '2101', bizList: ['2501', '2502', '2503', '2504']},
          {
            nodeName: '人员资料管理',
            nodeId: '2102',
            bizList: ['2601', '2602', '2603', '2604', '2605', '2606', '2607', '2608', '2609', '2610', '2611', '2901', '2902', '2903', '2904', '2906', '3201', '3202', '2701', '2702', '2703', '2704', '2705', '2706', '2707', '3301', '4411']
          }]
      },
      {
        nodeName: '身份介质管理',
        nodeId: '220',
        childNodeList: [
          {nodeName: '人脸管理', nodeId: '2201', bizList: ['2901', '2902', '2903', '2904', '2906']},
          {nodeName: '二维码管理', nodeId: '2204', bizList: ['3201', '3202']},
          {
            nodeName: '卡务管理',
            nodeId: '2202',
            bizList: ['2701', '2702', '2703', '2704', '2705', '2706', '2707', '2710', '4411']
          },
          {nodeName: '介质变更流水', nodeId: '2203', bizList: ['3001']},
          {nodeName: '人脸下载失败记录', nodeId: '2205', bizList: ['2905']}]
      },
      {
        nodeName: '发卡管理',
        nodeId: '230',
        childNodeList: [
          {nodeName: '制卡任务管理', nodeId: '2304', bizList: ['2801']},
          {nodeName: '制卡处理', nodeId: '2302', bizList: ['2802']},
          {nodeName: '制卡资料导出', nodeId: '2303', bizList: ['2803']},
          {nodeName: '外部卡激活', nodeId: '2305', bizList: ['2709']}]
      },
      {
        nodeName: '设备管理',
        nodeId: '240',
        childNodeList: [
          {nodeName: '厂家信息', nodeId: '2401', bizList: ['601', '602', '603', '604']},
          {nodeName: '产品类型', nodeId: '2402', bizList: ['701', '702', '703', '704']},
          {nodeName: '设备型号', nodeId: '2403', bizList: ['801', '802', '803', '804']},
          {nodeName: '设备资料', nodeId: '2404', bizList: ['901', '902', '903', '904', '905']},
          // {nodeName: '运维管理', nodeId: '2405', bizList: ['1001', '1002', '1003', '1004', '1005', '1006']},
          {nodeName: '应用软件版本', nodeId: '2406', bizList: ['1004']},
          {nodeName: '设备状态流水', nodeId: '2407', bizList: ['1005']},
          {nodeName: 'license管理', nodeId: '2408', bizList: ['1101', '1102', '1103', '1104']}
        ]
      }, {
        nodeName: '商户管理',
        nodeId: '25',
        childNodeList: [
          {nodeName: '商户管理', nodeId: '2501', bizList: ['3101', '3102', '3103', '3104']},
          {nodeName: '区域管理', nodeId: '2502', bizList: ['3401', '3402', '3403', '3404']},
          {nodeName: '终端安装地点', nodeId: '2503', bizList: ['3501', '3502', '3503', '3504']},
          {nodeName: '终端消费地点', nodeId: '2504', bizList: ['3601', '3602', '3603', '3604']}
        ]
      }
    ]
  },
  {
    nodeName: '消费管理',
    nodeId: '3',
    childNodeList: [
      {
        nodeName: '终端管理',
        nodeId: '430',
        childNodeList: [
          {nodeName: '终端资料', nodeId: '4301', bizList: ['4701', '4702', '4703', '4704', '4705']},
          {nodeName: '个性化设置', nodeId: '4302', bizList: ['4707']},
          {nodeName: '工作参数设置', nodeId: '4303', bizList: ['4708']}
        ]
      },
      {
        nodeName: '消费参数管理',
        nodeId: '310',
        childNodeList: [
          {nodeName: '工作时段设置', nodeId: '3101', bizList: ['4001', '4002', '4003', '4004']},
          {nodeName: '结算资料管理', nodeId: '3102', bizList: ['4101', '4102', '4103', '4104', '4105']},
          {nodeName: '单笔限额设置', nodeId: '3103', bizList: ['4201', '4202', '4203']},
          {nodeName: '人员时段限额', nodeId: '4202', bizList: ['4601', '4602', '4603', '4604', '4605']},
          {nodeName: '人员每日限额', nodeId: '4203', bizList: ['4601', '4602', '4603', '4604', '4605']},
          {nodeName: '人员计次消费', nodeId: '4204', bizList: ['4611', '4612', '4613', '4614', '4615', '4616']},
          {nodeName: '人员类别定额消费', nodeId: '4205', bizList: ['4621', '4622', '4623', '4624', '4625']}
        ]
      },
      {
        nodeName: '福利设置',
        nodeId: '320',
        childNodeList: [
          {nodeName: '福利应用设置', nodeId: '3201', bizList: ['4301', '4302', '4303']},
          {nodeName: '集体优惠设置', nodeId: '3202', bizList: ['4305', '4306', '4307', '4311']},
          {nodeName: '个人优惠设置', nodeId: '3203', bizList: ['4308', '4309', '4310', '4311']}
        ]
      },
      {
        nodeName: '账务管理',
        nodeId: '330',
        childNodeList: [
          {nodeName: '账户资料', nodeId: '3301', bizList: ['4407']},
          {nodeName: '单张补单', nodeId: '3302', bizList: ['4421']},
          {nodeName: '手工退货', nodeId: '3501', bizList: ['4410']},
          // {nodeName: '账户交易记录', nodeId: '450002', bizList: ['4408']}
          {nodeName: '费用参数设置', nodeId: '3803', bizList: ['3301']},
          {nodeName: '费用记录查询', nodeId: '3804', bizList: ['3301']},
          {nodeName: '收取工本费', nodeId: '3801', bizList: ['4411']},
          {nodeName: '异常查询', nodeId: '3802', bizList: ['6001', '6002', '6003']}
          // {nodeName: '未取餐退款', nodeId: '3601', bizList: []}
        ]
      },
      {
        nodeName: '充值/划拨',
        nodeId: '340',
        childNodeList: [
          {nodeName: '预支充值', nodeId: '3401', bizList: ['4405', '4406', '4414']},
          {nodeName: '旧卡余额结转', nodeId: '3402', bizList: ['4403', '4404', '4415']},
          {nodeName: '现金充值', nodeId: '3403', bizList: ['4401', '4402']},
          {nodeName: '外部码充值', nodeId: '3407', bizList: ['4422', '4423']},
          {nodeName: '充值撤销', nodeId: '3404', bizList: ['4408', '4402', '4404', '4406']},
          {nodeName: '补助金划拨', nodeId: '3405', bizList: ['4417']},
          {nodeName: '批量充值/划拨记录', nodeId: '3406', bizList: ['4403', '4404', '4415']}
        ]
      },
      {
        nodeName: '流水查询',
        nodeId: '390',
        childNodeList: [
          {nodeName: '分户流水', nodeId: '4500', bizList: ['4501']},
          {nodeName: '终端交易流水', nodeId: '4510', bizList: ['4502']},
          {nodeName: '非终端交易流水', nodeId: '4520', bizList: ['4503']},
          {nodeName: '销户流水', nodeId: '3303', bizList: ['4413', '4412']},
          {nodeName: '个人账户流水', nodeId: '4530', bizList: ['4504']},
          {nodeName: '个人交易流水', nodeId: '4540', bizList: ['4505']}
        ]
      },
      {
        nodeName: '就餐管理',
        nodeId: '370',
        childNodeList: [
          {nodeName: '就餐登记统计', nodeId: '3701', bizList: ['4960']},
          {nodeName: '就餐登记明细', nodeId: '3702', bizList: ['4961']},
          {nodeName: '团餐管理', nodeId: '5601', bizList: ['5601', '5602', '5603', '5604']},
          {nodeName: '团餐统计查询', nodeId: '5605', bizList: ['5605']}
        ]
      },
      {
        nodeName: '报表',
        nodeId: '49',
        childNodeList: [
          {nodeName: '终端交易日报表', nodeId: '6101', bizList: ['4901']},
          {nodeName: '终端交易汇总', nodeId: '6102', bizList: ['4902']},
          {nodeName: '商户清算日报表', nodeId: '6103', bizList: ['4903']},
          {nodeName: '商户清算汇总', nodeId: '6104', bizList: ['4904']},
          {nodeName: '商户订餐清算汇总', nodeId: '6118', bizList: ['4917']},
          {nodeName: '终端时段日报表', nodeId: '6105', bizList: ['4905']},
          {nodeName: '终端时段汇总', nodeId: '6106', bizList: ['4906']},
          {nodeName: '商户时段日报表', nodeId: '6125', bizList: ['4918']},
          {nodeName: '商户时段汇总', nodeId: '6107', bizList: ['4907']},
          {nodeName: '充值明细', nodeId: '4926', bizList: ['4926']},
          {nodeName: '充值统计报表', nodeId: '6108', bizList: ['4908']},
          // {nodeName: '应用账户余额报表', nodeId: '6109', bizList: ['4909']},
          {nodeName: '应收应付明细报表', nodeId: '6110', bizList: ['4910']},
          // {nodeName: '应收应付汇总报表', nodeId: '6111', bizList: ['4911']},
          {nodeName: '个人优惠明细', nodeId: '6112', bizList: ['4912']},
          {nodeName: '个人优惠汇总', nodeId: '6113', bizList: ['4913']},
          {nodeName: '优惠汇总报表', nodeId: '6114', bizList: ['4914']},
          {nodeName: '水牌消费明细', nodeId: '4920', bizList: ['4920']},
          {nodeName: '水牌时段日报表', nodeId: '6126', bizList: ['4932']},
          {nodeName: '水牌消费汇总', nodeId: '4927', bizList: ['4927']},
          {nodeName: '差错账报表', nodeId: '4921', bizList: ['4921']},
          {nodeName: '餐次窗口消费统计', nodeId: '4922', bizList: ['4922']},
          {nodeName: '窗口消费统计表', nodeId: '4923', bizList: ['4923']},
          {nodeName: '财务结算报表', nodeId: '4924', bizList: ['4924']},
          {nodeName: '系统月度对账单', nodeId: '4925', bizList: ['4925']},
          {nodeName: '计次消费统计报表', nodeId: '6115', bizList: ['4915']},
          {nodeName: '被扫交易流水', nodeId: '6116', bizList: ['4970', '4972']},
          {nodeName: '被扫交易统计', nodeId: '6117', bizList: ['4971']},
          {nodeName: '业务收支明细表', nodeId: '6119', bizList: ['4928']},
          {nodeName: '人员消费汇总表', nodeId: '6120', bizList: ['4929']},
          {nodeName: '部门时段消费汇总', nodeId: '6121', bizList: ['4930']},
          {nodeName: '部门餐次汇总日报表', nodeId: '6127', bizList: ['4933']},
          {nodeName: '消费时段日报表', nodeId: '6122', bizList: ['4931']},
          {nodeName: '销户统计表', nodeId: '6123', bizList: ['4419']},
          {nodeName: '销户结清日报表', nodeId: '6124', bizList: ['4420']}
        ]
      }
    ]
  },
  {
    nodeName: '缴费管理',
    nodeId: '4',
    childNodeList: [
      {
        nodeName: '缴费管理',
        nodeId: '4801',
        bizList: ['4801', '4802', '4803', '4804', '4805', '4806', '4807', '4810', '4811', '4814']
      },
      {nodeName: '限制临时解除', nodeId: '4802', bizList: ['4808', '4809']},
      {nodeName: '缴费明细', nodeId: '4811', bizList: ['4817']},
      {nodeName: '缴费统计', nodeId: '4812', bizList: ['4812']},
      {nodeName: '缴费对账', nodeId: '4813', bizList: ['4816']}
    ]
  },
  {
    nodeName: '订餐管理',
    nodeId: '5',
    childNodeList: [
      {nodeName: '订餐参数', nodeId: '5000', bizList: ['5000', '5001']},
      {nodeName: '菜品类型', nodeId: '5101', bizList: ['5101', '5102', '5103', '5104']},
      {nodeName: '菜品信息', nodeId: '5201', bizList: ['5201', '5202', '5203', '5204', '5205']},
      {nodeName: '套餐管理', nodeId: '5301', bizList: ['5301', '5302', '5303', '5304', '5305', '5306']},
      {nodeName: '菜单管理', nodeId: '5401', bizList: ['5401', '5402', '5403', '5404', '5405']},
      {nodeName: '菜单使用设置', nodeId: '5501', bizList: ['5501', '5502', '5503', '5504']},
      {nodeName: '菜单日历', nodeId: '5502', bizList: ['5501', '5502', '5503', '5504']},
      // {nodeName: '团餐管理', nodeId: '5601', bizList: ['5601', '5602', '5603', '5604']},
      {
        nodeName: '订餐查询与统计',
        nodeId: '57',
        childNodeList: [
          {nodeName: '套餐备餐统计查询', nodeId: '5702', bizList: ['5702']},
          {nodeName: '菜品备餐统计查询', nodeId: '5705', bizList: ['5705']},
          {nodeName: '订餐统计查询', nodeId: '5703', bizList: ['5703']},
          {nodeName: '订餐明细查询', nodeId: '5701', bizList: ['5701', '5704']}
          // {nodeName: '团餐统计查询', nodeId: '5605', bizList: ['5605']}
        ]
      }
    ]
  },
  {
    nodeName: '电子餐牌',
    nodeId: '6',
    childNodeList: [
      {nodeName: '屏位管理', nodeId: '6001', bizList: ['6101', '6102', '6103', '6104']},
      {nodeName: '特色菜管理', nodeId: '6004', bizList: ['6401', '6402', '6403', '6404']},
      {nodeName: '节目管理', nodeId: '6002', bizList: ['6201', '6202', '6203', '6204', '6205']},
      {nodeName: '节目播放计划', nodeId: '6003', bizList: ['6301', '6302', '6303', '6304', '6305']}
    ]
  },
  {
    nodeName: '进销存管理',
    nodeId: '7',
    childNodeList: [
      {
        nodeName: '资料管理',
        nodeId: '67',
        childNodeList: [
          {nodeName: '仓库维护', nodeId: '6701', bizList: ['6701']},
          {nodeName: '商品品牌', nodeId: '6702', bizList: ['6702']},
          {nodeName: '商品类别', nodeId: '6703', bizList: ['6703']},
          {nodeName: '计量单位', nodeId: '6704', bizList: ['6704']},
          {nodeName: '供应商', nodeId: '6705', bizList: ['6705']},
          {nodeName: '商品信息', nodeId: '6706', bizList: ['6706']}
        ]
      },
      {
        nodeName: '入库管理',
        nodeId: '68',
        childNodeList: [
          {nodeName: '采购进货', nodeId: '6802', bizList: ['6802']},
          {nodeName: '零星入库', nodeId: '6801', bizList: ['6801']}
        ]
      },
      {
        nodeName: '出库管理',
        nodeId: '69',
        childNodeList: [
          {nodeName: '供应商退货', nodeId: '6901', bizList: ['6901']},
          {nodeName: '手工出库', nodeId: '6902', bizList: ['6902']}
        ]
      },
      {
        nodeName: '库存管理',
        nodeId: '70',
        childNodeList: [
          {nodeName: '商品库存', nodeId: '7001', bizList: ['7001']},
          {nodeName: '报损', nodeId: '7002', bizList: ['7002']},
          {nodeName: '盘点', nodeId: '7003', bizList: ['7003']}
        ]
      },
      {
        nodeName: '销售管理',
        nodeId: '71',
        childNodeList: [
          {nodeName: '销售调价', nodeId: '7101', bizList: ['7101']},
          {nodeName: '销售明细', nodeId: '7102', bizList: ['7102']},
          {nodeName: '销售汇总', nodeId: '7103', bizList: ['7103']},
          {nodeName: '销售退货', nodeId: '7104', bizList: ['7104']},
          {nodeName: '其他收入', nodeId: '7105', bizList: ['7105']},
          {nodeName: '在途订单', nodeId: '7106', bizList: ['7106']}
        ]
      },
      {
        nodeName: '汇总报表',
        nodeId: '72',
        childNodeList: [
          {nodeName: '出入库汇总', nodeId: '7201', bizList: ['7201']},
          {nodeName: '商户营收汇总', nodeId: '7202', bizList: ['7202']},
          {nodeName: '渠道销售汇总', nodeId: '7203', bizList: ['7203']},
          {nodeName: '收银汇总', nodeId: '7204', bizList: ['7204']},
          {nodeName: '供应商供货汇总', nodeId: '7205', bizList: ['7205']},
          {nodeName: '供应商付款汇总', nodeId: '7206', bizList: ['7206']}
        ]
      }
    ]
  }
]

// let tempPassSettingList = []

let instImg = {} // 机构自定义名称及logo、背景图片

let productList = [
  {codeName: '消费', codeNo: '1'},
  {codeName: '门禁', codeNo: '2'},
  {codeName: '缴费', codeNo: '3'}
]

let idTypeSorts = [] // 证件类型
let genderSorts = [] // 性别

let merchantList = [] // 商户下拉框列表
let deptList = [] // 部门下拉框列表
let dictTypeList = [] // 所有字典类型列表
let mtDictTypeList = [] // 可维护字典类型列表
let deviceFactoryList = [] // 设备厂商列表
let factoryProductList = [] // 厂商产品列表
let productModelList = [] // 产品型号列表
let deviceSorts = [] // 设备列表
let licenseList = [] // license下拉框列表
let paymentTypeSorts = [] // 缴费项目类型
let orderFoodPeriodTypeSorts = [] // 订餐期长类型
let batchStatusSorts = [] // 批次状态

let personnelSorts = [] // 人员类别
let personnelPostSorts = [] // 人员职务
let dishSorts = [] // 菜品类别

let basicDataStatusSorts = [] // 基本数据状态
let operatorStatusSorts = [] // 操作员状态

let validAmountReg = /^\s*[0-9]{1,6}(.[0-9]{1,2})?\s*$/ // 金额校验规则（两位小数
let validNaturalNumReg = /^(0|\+?[1-9][0-9]*)$/ // 正整数

export default {
  publicKey,
  pinKey,
  macKeyObj,
  defaultMacKey,
  defaultPinKey,
  defaultToken,
  saveKey,
  schCode,
  instImg,
  headerTitle,
  loginInfo,
  user,
  getWorkKeysUrl,
  needLoadingRequestCount,
  isEncryption,
  cryptionType,
  lastRequestFlag,
  treeProps,
  categoryTreeProps,
  hideError,
  ruleId,
  userId,
  handleType,
  userName,
  privileges,
  errorSubmit,
  noChangeTitle,
  noChangeMsg,
  breadcrumbContent,
  lastBreadcrumbContent,
  timestamp,
  initMaxPageSize,
  initPageSize,
  initPageNum,
  clientWidth,
  clientHeight,
  contentWidth,
  contentHeight,
  lastBizList,
  bizList,
  menuList,
  initMenuList,
  productList,
  idTypeSorts,
  genderSorts,
  personnelSorts,
  personnelPostSorts,
  dishSorts,
  basicDataStatusSorts,
  operatorStatusSorts,
  merchantList,
  deptList,
  dictTypeList,
  deviceFactoryList,
  factoryProductList,
  productModelList,
  paymentTypeSorts,
  orderFoodPeriodTypeSorts,
  deviceSorts,
  batchStatusSorts,
  showCleanSector,
  licenseList,
  supportOutsideCard,
  mtDictTypeList,
  validAmountReg,
  validNaturalNumReg,
  userPrivileges
}



// WEBPACK FOOTER //
// ./src/store/state.js